import * as React from 'react';
import type { InteractiveCanvasComponents } from '@mentimeter/question-modules-types';

const interactiveCanvasContext =
  React.createContext<InteractiveCanvasComponents>({});
interactiveCanvasContext.displayName = 'InteractiveCanvasContext';
export const InteractiveCanvasProvider = interactiveCanvasContext.Provider;
export const useInteractiveCanvas = () =>
  React.useContext(interactiveCanvasContext);
